import { Result } from './result'

export interface FcmResponse {
    multicast_id: number;
    success: number;
    failure: number;
    canonical_ids: number;
    results: Result[];
}